// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"39a46f1e","232":"d158d478","237":"83105786","301":"4be9287a","357":"a206cabc","526":"63cb9da3","753":"7b1b5128","854":"6ab77096","872":"49966339"}[chunkId] + ".chunk.js";
};